import client from '../client/loginClient';
export default class Model {
    public resultData = null;
    public ajaxLoginData = null;

    public async logout(params: any) {
        const result = await client.logout(params);
        if (result) {
            this.resultData = result;
        }
    }
}
